// header options
export const headerOptions = {
    MODULE_EDITOR_VIEW: 'Module View',
    VARIABLES: 'Variables',
    WORKFLOWS: 'Workflows',
    VERSIONS: 'Versions',
    AI_COPILOT: 'AI Copilot',
    LOCALIZATION: 'Localization'
};
